/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orgName: NonNullable<unknown> }} Partner_Org_Contract_Approve_TitleInputs */



/**
* | output |
* | --- |
* | "Approve {orgName}'s contract?" |
*
* @param {Partner_Org_Contract_Approve_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_approve_title = /** @type {((inputs: Partner_Org_Contract_Approve_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Approve_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Vertrag von ${i?.orgName} freigeben?`)
	return /** @type {LocalizedString} */ (`Approve ${i?.orgName}'s contract?`)
});